import dayjs from 'dayjs'

export const now = () => dayjs()
export const parseDateString = (dateString: string) => dayjs(dateString, 'DD.MM.YYYY', true)

export const isValidDate = (date: any) => {
  const parsedDate = dayjs.isDayjs(date) ? date : parseDateString(date)
  return !!parsedDate.isValid()
}

export const generateExpectedStartOfInsurance = () => now().add(1, 'month').set('date', 1).format('DD.MM.YYYY')

export const generateCurrentDate = () => now().format('DD.MM.YYYY')
